import React from 'react';
export function TransformationSection() {
  return <section className="s-dark fu" data-id="element-644">
      <div className="c text-center" data-id="element-645">
        <span className="slabel" data-id="element-646">La transformación</span>
        <h2 className="stitle" data-id="element-647">
          De cargar el dolor a{' '}
          <em className="text-[var(--gold-l)]" data-id="element-648">cerrarlo para siempre.</em>
        </h2>
        <div className="div-line" data-id="element-649"></div>
      </div>

      <div className="fu grid grid-cols-1 md:grid-cols-2 gap-[2px] max-w-[880px] mx-auto mt-8 md:mt-[56px] border border-[rgba(184,174,206,0.2)] rounded-[20px] overflow-hidden w-full px-4 md:px-0" data-id="element-650">
        <div className="p-6 md:p-10 bg-[var(--bg3)] md:border-r border-b md:border-b-0 border-[rgba(212,184,150,0.2)] shadow-[0_8px_32px_rgba(0,0,0,0.35)] text-center" data-id="element-651">
          <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 mb-5 md:mb-7 flex items-center justify-center gap-2.5 text-[var(--gold-l)]" data-id="element-652">
            <span className="text-[17px]" data-id="element-653">✗</span> Sin el kit
          </h3>
          <ul className="list-none flex flex-col gap-[16px] items-center max-w-[480px] mx-auto" data-id="element-654">
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-655">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-656"></span>
              Cargás algo que no podés nombrar pero sentís todo el tiempo
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-657">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-658"></span>
              Volvés al mismo dolor aunque ya "lo trabajaste"
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-659">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-660"></span>
              Entendés la causa pero el cuerpo sigue cargando
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-661">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-662"></span>
              Conversaciones incompletas y relaciones sin cierre que siguen
              pesando
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-663">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-664"></span>
              Esperás que el tiempo cure lo que necesita un cierre real
            </li>
          </ul>
        </div>

        <div className="p-6 md:p-10 bg-[var(--bg3)] border-l-2 border-l-[rgba(212,184,150,0.2)] shadow-[0_8px_32px_rgba(0,0,0,0.35)] text-center" data-id="element-665">
          <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 mb-5 md:mb-7 flex items-center justify-center gap-2.5 text-[var(--gold-l)]" data-id="element-666">
            <span className="text-[17px]" data-id="element-667">✦</span> Con el kit
          </h3>
          <ul className="list-none flex flex-col gap-[16px] items-center max-w-[480px] mx-auto" data-id="element-668">
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-669">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-670"></span>
              <span data-id="element-671">
                Un{' '}
                <strong className="text-[var(--gold-l)] font-700" data-id="element-672">
                  cierre real
                </strong>{' '}
                — tu cuerpo lo registra, no solo tu mente
              </span>
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-673">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-674"></span>
              <span data-id="element-675">
                <strong className="text-white font-700" data-id="element-676">
                  Herramientas concretas
                </strong>{' '}
                para cada tipo de herida emocional
              </span>
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-677">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-678"></span>
              Tu sistema nervioso suelta lo que la razón ya entendió
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-679">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-680"></span>
              Ciclos que se cierran de verdad con un proceso íntimo y a tu ritmo
            </li>
            <li className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] flex items-start gap-2.5 text-[var(--text)] font-400 text-left w-full" data-id="element-681">
              <span className="flex-shrink-0 mt-2 w-[6px] h-[6px] rounded-full bg-[var(--gold)]" data-id="element-682"></span>
              <span data-id="element-683">
                La sensación genuina de que{' '}
                <span className="text-[var(--gold-l)] font-700" data-id="element-684">
                  ese peso ya no es tuyo
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}